"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M19 2H1c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zM7 14V6l6 4-6 4z"];
//# sourceMappingURL=video.js.map